import Marquee3k from "marquee3000";

export const ticker = function (el) {
    Marquee3k.init();
    el.addEventListener("mouseenter", function () {
        el.setAttribute("data-speed", 0.1);
        Marquee3k.refreshAll();
    });
};
